import React, { useEffect, useState } from 'react';
import { listUploadLogs } from '../../api/api';

export default function UploadHistoryTableContainer({ onViewLog }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const data = await listUploadLogs();
      setRows(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  if (loading) return <div>Loading history…</div>;

  return (
    <div>
      <h3>Upload History</h3>
      <table width="100%" cellPadding="8" style={{ borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Filename</th>
            <th>Mode</th>
            <th>Status</th>
            <th>Total</th>
            <th>Imported</th>
            <th>Failed</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(log => (
            <tr key={log.id} style={{ borderTop: '1px solid #eee' }}>
              <td>#{log.id}</td>
              <td>{log.filename || '-'}</td>
              <td style={{ fontSize: 12 }}>
                {log.catalog_upload_mode === 'full_replace' ? 'Full replace' : 'Partial'}
              </td>
              <td>
                <span
                  style={{
                    padding: '2px 8px',
                    borderRadius: 8,
                    background: log.status === 'complete' ? '#e6ffed' : '#fff7e6',
                    border: '1px solid #ddd'
                  }}
                >
                  {log.status}
                </span>
              </td>
              <td>{log.total_rows}</td>
              <td>{log.successful_imports}</td>
              <td>{log.failed_imports}</td>
              <td>
                <button
                    onClick={() => onViewLog?.(log.id, log.status)}
                    title="View"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
                    >
                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 5c-5 0-9 5-9 7s4 7 9 7 9-5 9-7-4-7-9-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 
                            5-5 5 2.24 5 5-2.24 5-5 5zm0-8a3 3 0 100 6 3 3 0 000-6z"/>
                    </svg>
                </button>
              </td>

            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={8} style={{ textAlign: 'center' }}>No uploads yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
